import React from 'react';
import useMemo from '@/util/hook/useMemo';
import { BUTTON_SIZE } from '@/config/ui/button';
import { ForwardButton } from '../../component/atom/Button';
import Description from '../../component/atom/Description';
import Header from '../../component/atom/Header';
import InputRadio from '../../component/atom/Input/InputRadio';
import InputText from '../../component/atom/Input/InputText';
import Label from '../../component/atom/Label';
import FootNotes from '../../component/composite/FootNotes';
import RWDPageLayout from '../../component/composite/RWDPageLayout';
import { S } from './style';
import { APP } from '../../config/app';
import { FORM_FIELD_ERROR_FEEDBACK_TEXT } from '../../config/error';
const renderHeader = () => (<Header progress={APP.PAGE_PROGRESS_INFO['/contactInfo'].progress} progressTitle={APP.PAGE_PROGRESS_INFO['/contactInfo'].title}/>);
const renderDescription = () => (<Description content={<>
        系統將會在找到照服員時通知您。
        <br />
        請放心，在照服員開始服務時，您不會被收取任何照顧費用。
      </>}/>);
const renderContactNameField = ({ contactName, isContactNameError, careOrderBabyFormInputFieldRefMap, handleContactNameInputChange, }) => (<InputText elementRef={careOrderBabyFormInputFieldRefMap.contactName} align='full' title='姓名' placeholder='請輸入' inputType='text' value={contactName || ''} onInputChange={handleContactNameInputChange} isError={isContactNameError} errMessage={contactName
        ? FORM_FIELD_ERROR_FEEDBACK_TEXT.INVALID_FORMAT
        : FORM_FIELD_ERROR_FEEDBACK_TEXT.EMPTY_NOT_ALLOWED}/>);
const renderContactGenderField = ({ contactGender, isContactGenderError, genderOptionList, careOrderBabyFormInputFieldRefMap, handleContactGenderInputChange, }) => (<InputRadio elementRef={careOrderBabyFormInputFieldRefMap.contactGender} title='性別' radioGroupName='contactGender' optionList={genderOptionList} refValue={contactGender || ''} onInputChange={handleContactGenderInputChange} isError={isContactGenderError} errMessage={FORM_FIELD_ERROR_FEEDBACK_TEXT.EMPTY_NOT_ALLOWED}/>);
const renderContactPhoneField = ({ contactPhone, isContactPhoneError, careOrderBabyFormInputFieldRefMap, handleContactPhoneInputChange, }) => (<div>
    <InputText elementRef={careOrderBabyFormInputFieldRefMap.contactPhone} align='full' title='電話' placeholder='請輸入' inputType='tel' value={contactPhone || ''} maxLength={10} onInputChange={handleContactPhoneInputChange} isError={isContactPhoneError} errMessage={FORM_FIELD_ERROR_FEEDBACK_TEXT.INVALID_PHONE_NUMBER}/>
    <FootNotes content={<>
          照服員會與上方您填寫的家屬聯絡。
          <br />
          若派案人與現場家屬不同，請確保現場家屬了解平台相關規則。
        </>} customStyle='margin: -8px 0 5px 5px'/>
  </div>);
const renderContactEmailField = ({ contactEmail, isContactEmailError, careOrderBabyFormInputFieldRefMap, handleContactEmailInputChange, }) => (<div>
    <InputText elementRef={careOrderBabyFormInputFieldRefMap.contactEmail} align='full' title='Email' placeholder='請輸入（非必填）' inputType='email' value={contactEmail || ''} onInputChange={handleContactEmailInputChange} isError={isContactEmailError} errMessage={FORM_FIELD_ERROR_FEEDBACK_TEXT.INVALID_FORMAT}/>
    <FootNotes content='我們將寄送相關資訊至您的email。' customStyle='margin: -8px 0 0 5px'/>
  </div>);
const renderFooter = ({ handleForwardButtonClick, }) => (<S.LayoutFooter>
    <ForwardButton size={BUTTON_SIZE.LARGE} isAvailable onButtonClick={handleForwardButtonClick}>
      下一步
    </ForwardButton>
  </S.LayoutFooter>);
export default function View({ 
// data
isLoading, contactName, contactGender, contactPhone, contactEmail, isContactNameError, isContactGenderError, isContactPhoneError, isContactEmailError, genderOptionList, careOrderBabyFormInputFieldRefMap, 
// func
handleContactNameInputChange, handleContactGenderInputChange, handleContactPhoneInputChange, handleContactEmailInputChange, handleForwardButtonClick, }) {
    const header = useMemo(() => renderHeader(), []);
    const description = useMemo(() => renderDescription(), []);
    const contactNameField = useMemo(() => renderContactNameField({
        contactName,
        isContactNameError,
        careOrderBabyFormInputFieldRefMap,
        handleContactNameInputChange,
    }), [
        contactName,
        isContactNameError,
        careOrderBabyFormInputFieldRefMap,
        handleContactNameInputChange,
    ]);
    const contactGenderField = useMemo(() => renderContactGenderField({
        contactGender,
        isContactGenderError,
        genderOptionList,
        careOrderBabyFormInputFieldRefMap,
        handleContactGenderInputChange,
    }), [
        contactGender,
        isContactGenderError,
        genderOptionList,
        careOrderBabyFormInputFieldRefMap,
        handleContactGenderInputChange,
    ]);
    const contactPhoneField = useMemo(() => renderContactPhoneField({
        contactPhone,
        isContactPhoneError,
        careOrderBabyFormInputFieldRefMap,
        handleContactPhoneInputChange,
    }), [
        contactPhone,
        isContactPhoneError,
        careOrderBabyFormInputFieldRefMap,
        handleContactPhoneInputChange,
    ]);
    const contactEmailField = useMemo(() => renderContactEmailField({
        contactEmail,
        isContactEmailError,
        careOrderBabyFormInputFieldRefMap,
        handleContactEmailInputChange,
    }), [
        contactEmail,
        isContactEmailError,
        careOrderBabyFormInputFieldRefMap,
        handleContactEmailInputChange,
    ]);
    const footer = useMemo(() => renderFooter({ handleForwardButtonClick }), [handleForwardButtonClick]);
    return (<RWDPageLayout isLoading={isLoading}>
      {header}
      <S.Layout>
        {description}
        <S.LayoutInputFields>
          <Label title='家屬聯絡資訊'/>
          {contactNameField}
          {contactGenderField}
          {contactPhoneField}
          {contactEmailField}
        </S.LayoutInputFields>
        {footer}
      </S.Layout>
    </RWDPageLayout>);
}
